import { Typography } from 'antd'

export const Paragraph = Typography.Paragraph
